import React, { useState } from "react";
import {
  ModalForm,
  ProForm,
  ProFormText,
} from '@ant-design/pro-components';
import { Button, Form, message, Popconfirm } from 'antd';
import { dealingComplaint } from "../../service/complaint";

export default function ConfirmHandle(props) {
  // 投诉编号, 是否完成退款，是否处理完成，处理完成回调
  const { complain_no, isCompleteRefund, isProcessComplete, processCompleteCB } = props
  const [form] = Form.useForm();

  const [modalVisit, setModalVisit] = useState(false);

  // 控制是否展现 Popconfirm
  const [open, setOpen] = useState(false);
  // popconfirm 确认回调
  const confirm = () => {
    setOpen(false);
    setModalVisit(true);
  };

  // popconfirm 状态变更时的回调
  const handleOpenChange = (newOpen) => {
    if (isProcessComplete) return

    if (!newOpen) {
      setOpen(newOpen);
      return;
    }
    console.log('lyn test = ', isCompleteRefund)
    if (isCompleteRefund) {
      // 完成退款，直接走处理完成的逻辑
      confirm()
    } else {
      // 没完成退款，则在处理完成前让用户确认是否继续
      setOpen(newOpen);
    }
  };

  return (
    <>
      <Popconfirm
        title="退款情况确认"
        description="没有完成退款，确认和用户协商一致？"
        open={open}
        onOpenChange={handleOpenChange}
        onConfirm={confirm}
        okText="确认"
        cancelText="取消"
      >
        <Button type="link" disabled={isProcessComplete}>
          处理完成
        </Button>
      </Popconfirm>
      <ModalForm
        title="确认处理完，结束这一条工单？"
        open={modalVisit}
        onOpenChange={setModalVisit}
        form={form}
        autoFocusFirstInput
        modalProps={{
          destroyOnClose: true,
          maskClosable: false,
        }}
        onFinish={async (values) => {
          const { remark } = values
          if (!remark) {
            message.error('请输入工单处理备注')
            return
          }
          await dealingComplaint({
            complain_no,
            content: remark,
            code: "05",
          })
          message.success('提交成功');
          processCompleteCB()
          return true;
        }}
      >
        <ProForm.Group>
          <ProFormText
            width="md"
            name="remark"
            label="备注"
            required
            placeholder="请输入工单处理备注"
          />
        </ProForm.Group>
      </ModalForm>
    </>
  );
};